import { BaseReq, PaginationReq, PaginationResp, UpdaterResp, FileRecord } from "@/core/interface";
import { getCurrentUserId } from "@/utils";

// 类目明细
export class CategoryRecord extends BaseReq {
  uuid: string = ""; // 唯一ID
  projectFundId: string | undefined = undefined; // 工程款项ID
  budget: number = 0 ; // 方案预算
  ratio: number = 0; // 占比
  remark: string = ""; // 备注
}
// 租赁预算
export class LeaseRecord extends BaseReq {
  uuid: string = ""; // 唯一ID
  leaseTask: string | undefined = undefined; // 任务
  leaseBudget: number = 0 ; // 预算
  describe: string = ""; // 备注
}
// 分包预算
export class SubcontractRecord extends BaseReq {
  uuid: string = ""; // 唯一ID
  subtask: string | undefined = undefined; // 任务
  subBudget: number = 0 ; // 预算
  subcontractType:  string | undefined = undefined; // 类型
  describe: string = ""; // 备注
}

// 工程量清单
export class QuantityRecord extends BaseReq {
  id: string = "";
  uuid: string = ""; // 唯一ID
  bizNo: string = ""; // 业务编号
  name: string = ""; // 清单名称
  feature: string = ""; // 项目特征
  unit: string = ""; // 结算单位
  count: number = 0 ; // 工程量
  price: number = 0 ; // 综合单价
  totalPrice: number = 0; // 合价
  remark: string = ""; // 备注
}

export class MaterialRecord extends BaseReq {
  id: string = "";
  uuid: string = ""; // 唯一ID
  bizNo: string = ""; // 业务编号
  materialId: string = ""; // 材料 ID
  materialNo: string = ""; // 材料编号
  materialName: string = ""; // 材料名称
  materialBrand: string = ""; // 品牌
  materialModel: string = ""; // 规格型号
  materialUnit: string = ""; // 结算单位
  count: number = 0 ; // 数量
  price: number = 0 ; // 单价
  demandTime: string = ""; // 需求日期
  isInnerContract: boolean = true; // 是否合同内
  totalPrice: number = 0; // 合价
  remark: string = ""; // 备注
  systemName:string="";// 系统名称
  sortFiled: number = 1;
  materialCategoryName: string = ""; // 材料分类名称
  materialCategoryId: string = ""; // 材料分类 ID
  costPrice: number = 0; // 成本价
  salesPrice: number = 0; // 销售价
}

export class BudgetReq extends BaseReq {
  projectId: string | undefined = undefined; // 项目ID
  projectAmount: number = 0; // 工程合同金额
  totalWorkBudget: number = 0; // 施工总预算
  generalBudget: number = 0; // 自定义类目总预算
  procurementBudget: number = 0; // 采购预算
  subcontractingBudget: number = 0; // 分包预算
  leaseBudget: number = 0; // 租赁预算
  budgetTenantUserId: string = getCurrentUserId(); // 预算负责人ID
  remark: string = ""; // 备注
  categoryAReqs: CategoryRecord[] = []; // 类目明细
  quantitiesAReqs: QuantityRecord[] = []; // 工程量清单
  materialAReqs: MaterialRecord[] = []; // 材料清单
  budgetLeaseReq: LeaseRecord[]=[]
  budgetSubReq: SubcontractRecord[]=[]
  fileList: FileRecord[] = []; //附件
  changeCount:number = 0; //变更次数
  totalQuantitiesBudget: number = 0; // 工程量清单预算
}

export class BudgetPageReq extends PaginationReq {
  name: string | undefined = undefined; // 项目名称
  budgetTenantUserId: string | undefined = undefined; // 预算负责人
  flowStatus: string = "dtj"; //状态
}

export class BudgetListRecord extends UpdaterResp {
  id: number = 0; // 施工预算ID
  bidNo: string = ""; // 施工预算编号
  name: string = ""; // 项目名称
  totalWorkBudget: number = 0; // 施工总预算
  totalQuantitiesBudget: number = 0; // 工程量清单总计
  totalMaterialBudget: number = 0; // 材料费总计
  budgetTenantUserId: string = ""; // 预算负责人ID
  budgetTenantUserName: string = ""; // 预算负责人姓名
  validStatus: string = ""; // 生效状态Code
  validStatusName: string = ""; // 生效状态名称
  flowStatus: string = ""; // 审批状态Code
  flowStatusName: string = ""; // 审批状态名称
}

export class BudgetPageResp extends PaginationResp<BudgetListRecord> {}

export class BudgetDetailResp extends UpdaterResp {
  id: string = ""; // 施工预算ID
  projectId: string = ""; // 项目ID
  projectName: string = ""; // 项目名称
  projectAmount: number = 0; // 工程合同金额
  totalWorkBudget: number = 0; // 项目总预算
  budgetTenantUserId: string = ""; // 预算负责人ID
  budgetTenantUserName: string = ""; // 预算负责人姓名
  remark: string = ""; // 备注
  changeCount: number = 0; 
}

export class QuantityCheckResp extends UpdaterResp {
  id: string = ""; // 合同ID
  existProjectWorkBudget: number = 0; // 	施工预算是否存在(0：不存在 1：存在)
  projectWorkBudgetId: number = 0; // 	施工预算ID
}
